import "./EditEquipmentTypeInformation.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditEquipmentTypeInformationComponentController from "./EditEquipmentTypeInformationComponentController";

export class EditEquipmentTypeInformationComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditEquipmentTypeInformationComponentController;
        this.templateUrl =
            "/App/Components/EquipmentType/" +
            "BasicInformation/EditEquipmentTypeInformation/EditEquipmentTypeInformation.html";
    }
}

module("mmManagePortal").component("irEditEquipmentTypeInformation", new EditEquipmentTypeInformationComponent());
